import ReactDOM from 'react-dom/client';
import {ChakraProvider} from '@chakra-ui/react';
import './index.css';
import App from './App';
import theme from './theme';
import {analytics} from './services/analytics';
import {installFirestoreRecovery} from './services/firestoreRecovery';
import AppErrorBoundary, {
  installPreloadErrorRecovery,
} from './components/common/AppErrorBoundary';

// Detect and recover from the fatal Firestore SDK watch-stream assertion that
// otherwise silently blanks Firestore-backed views (e.g. the scribe note).
installFirestoreRecovery();

// Recover from lazy-route chunks 404ing after a deploy replaced the hashed
// bundle files (the "white screen" / "Importing a module script failed"
// incident) by reloading once onto the fresh index.html.
installPreloadErrorRecovery();

analytics.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY as string, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  person_profiles: 'identified_only',
  // Keep replay enabled, but force PHI-safe masking even if remote replay
  // settings are changed later.
  capture_exceptions: {
    capture_unhandled_errors: true,
    capture_unhandled_rejections: true,
    capture_console_errors: false,
  },
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: 'body',
    captureCanvas: {
      recordCanvas: false,
    },
  },
  disable_session_recording: process.env.NODE_ENV === 'development',
  ...({
    enableExceptionAutocapture: true,
    enable_recording_console_log: false,
    mask_all_text: true,
    mask_personal_data_properties: true,
  } as any),
});

// Force light mode globally – the API Portal handles its own dark styling
// with hardcoded colors, independent of Chakra's color mode system.
if (typeof window !== 'undefined') {
  localStorage.setItem('chakra-ui-color-mode', 'light');
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode>
  <AppErrorBoundary>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </AppErrorBoundary>,
  // </React.StrictMode>
);
